import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/allowances")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Allowances")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 2000), toMinValue(10)), 2000),
  }),
  head: () => ({ meta: seo({ title: "Manage Allowances" }) }),
});
